export function closeModal(history) {
  // history.length equal to 1 is equivalent to having no history
  if (history.length > 1) {
    history.goBack();
  } else {
    history.push('/');
  }
}
